export default __webpack_public_path__ + "locales/fr/Ldap.json?hash=30973a4ff202e358f8b924eb2200dd16";